import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-creacion-paquete',
  templateUrl: './creacion-paquete.component.html',
  styleUrls: ['./creacion-paquete.component.css']
})
export class CreacionPaqueteComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
